// Core imports
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';

// Component imports
import NotificationAvatar from './NotificationAvatar';
import { Typography, Row, Col, Tooltip } from 'antd';

// Misc imports
import { useReadNotificationMutation } from '../../store/notifications/notificationsApi';
import { getTimeDifference } from '../../utils/date';

const NotificationCard = ({ notification, onNotificationClick }) => {
  const { orgId } = useParams();
  const [readNotificationMutation] = useReadNotificationMutation();

  const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const { currentUser } = useSelector((state) => state.auth);

  const { displayTime, detailedTime } = getTimeDifference(notification.createdDate, browserTimezone);

  const handleMarkAsRead = async () => {
    if (notification.read) {
      return;
    }
    try {
      const response = await readNotificationMutation({ orgId, id: notification.id, userId: currentUser.id });
      if (response.error) {
        console.error('Error while marking notification as read:', response.error);
        return;
      }
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };

  const renderListItem = () => (
    <Row
      onClick={handleMarkAsRead}
      className={classNames('fs-base pl-5 pr-5 mr-2', {
        'ant-btn-text pb-2 pt-2': notification.navLink,
        'pb-2 pt-1': !notification.navLink
      })}
      gutter={8}
      style={{
        borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
        cursor: !notification.read || notification.navLink ? 'pointer' : 'default'
      }}
    >
      <Col span={24}>
        <Row>
          <Col>
            <NotificationAvatar
              notification={notification}
              maxMessageCharacters={100}
            />
          </Col>
        </Row>
        <Row justify="end">
          <Col>
            <Tooltip title={detailedTime}>
              <Typography.Text type="secondary" className="fs-sm">
                {displayTime}
              </Typography.Text>
            </Tooltip>
          </Col>
        </Row>
      </Col>
    </Row>
  );

  return notification.navLink ? (
    <Link to={notification.navLink} onClick={onNotificationClick}>
      {renderListItem()}
    </Link>
  )
    : (
      renderListItem()
    );
};

NotificationCard.propTypes = {
  notification: PropTypes.shape({
    id: PropTypes.number.isRequired,
    userId: PropTypes.string,
    read: PropTypes.bool.isRequired,
    message: PropTypes.string.isRequired,
    createdDate: PropTypes.string.isRequired,
    navLink: PropTypes.string
  }).isRequired,
  onNotificationClick: PropTypes.func
};

export default NotificationCard;
